import { Notification } from '@app/components/various/Notification';
import { isEmpty } from '@app/utils/isEmpty';
import { Order } from '@typings';
import { useTranslation } from 'react-i18next';

interface Props {
  cancelledVariants: Order.Product[];
}

export const CheckoutProductAlerts = (props: Props) => {
  const { cancelledVariants } = props;
  const { t } = useTranslation(['cancelled']);
  const showCancelledVariants = !isEmpty(cancelledVariants);

  if (!showCancelledVariants) {
    return null;
  }

  return (
    <div>
      <Notification isBordered type="warning" message={t('cancelled:variants_cancelled', { count: cancelledVariants.length })} />
    </div>
  );
};
